import { ErrorOutline } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React, { memo } from 'react';

interface SaveErrorBannerProps {
	error: string | null;
}

const SaveErrorBanner = ({ error }: SaveErrorBannerProps) => {
	if (!error) return null;

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 0.5,
				p: 1,
				mt: 0.5,
				borderRadius: 1,
				bgcolor: 'error.dark',
				mb: 2
			}}
		>
			<ErrorOutline sx={{ fontSize: 16, color: 'error.contrastText' }} />
			<Typography variant="caption" color="error.contrastText">
				{error}
			</Typography>
		</Box>
	);
};

export default memo(SaveErrorBanner);
